import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Center, Loader } from '@mantine/core';
import { useEnrichedAuth } from '@/hooks/useEnrichedAuth';

/** Unauthenticated → /auth/login?redirect=<current url>. */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { isAuthenticated, isInitializing } = useEnrichedAuth();
  const location = useLocation();
  if (isInitializing) {
    return <Center h="50vh"><Loader /></Center>;
  }
  if (!isAuthenticated) {
    const redirect = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/auth/login?redirect=${redirect}`} replace />;
  }
  return <>{children}</>;
}
